const clients = [
  {
    name: '日禾和食',
    nameEn: 'Rihe Japanese',
    category: '餐飲空間',
    icon: 'ri-restaurant-2-line',
  },
  {
    name: '質選良品',
    nameEn: 'Zhixuan Select',
    category: '零售門市',
    icon: 'ri-store-2-line',
  },
  {
    name: 'Lumia 醫美',
    nameEn: 'Lumia Clinic',
    category: '診所醫美',
    icon: 'ri-heart-pulse-line',
  },
  {
    name: 'NOVA 創意',
    nameEn: 'NOVA Studio',
    category: '辦公空間',
    icon: 'ri-building-4-line',
  },
  {
    name: 'Horizon 建材',
    nameEn: 'Horizon Materials',
    category: '品牌展廳',
    icon: 'ri-layout-masonry-line',
  },
  {
    name: 'Le Kafé',
    nameEn: 'Le Kafé Coffee',
    category: '精品咖啡',
    icon: 'ri-cup-line',
  },
  {
    name: 'Muse 旅宿',
    nameEn: 'Muse Boutique Hotel',
    category: '精品旅館',
    icon: 'ri-hotel-line',
  },
  {
    name: 'GreenForm',
    nameEn: 'GreenForm Tech',
    category: '永續辦公',
    icon: 'ri-leaf-line',
  },
  {
    name: '原木生活',
    nameEn: 'Origin Living',
    category: '家居零售',
    icon: 'ri-home-smile-line',
  },
  {
    name: 'Aura SPA',
    nameEn: 'Aura Wellness',
    category: '美容空間',
    icon: 'ri-sparkling-line',
  },
  {
    name: '城市烘焙',
    nameEn: 'Urban Bakery',
    category: '烘焙品牌',
    icon: 'ri-cake-line',
  },
  {
    name: 'Flux 設計',
    nameEn: 'Flux Design Lab',
    category: '創意工作室',
    icon: 'ri-lightbulb-flash-line',
  },
];

// Duplicate for seamless loop
const loopClients = [...clients, ...clients];

export default function ClientsStrip() {
  return (
    <section className="py-14 md:py-16 bg-white border-y border-[#ede9e4] overflow-hidden">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10 mb-8">
        <div className="flex items-center gap-5">
          <div className="h-px flex-1 bg-[#e2ddd8]"></div>
          <p className="text-[#b8b0a6] text-xs font-medium tracking-[0.25em] uppercase whitespace-nowrap">
            Trusted by leading brands
          </p>
          <div className="h-px flex-1 bg-[#e2ddd8]"></div>
        </div>
      </div>

      {/* Marquee track */}
      <div className="relative">
        {/* Left fade */}
        <div className="absolute left-0 top-0 bottom-0 w-24 md:w-40 z-10 pointer-events-none bg-gradient-to-r from-white to-transparent"></div>
        {/* Right fade */}
        <div className="absolute right-0 top-0 bottom-0 w-24 md:w-40 z-10 pointer-events-none bg-gradient-to-l from-white to-transparent"></div>

        <div
          className="flex gap-4 w-max"
          style={{
            animation: 'marquee 36s linear infinite',
          }}
        >
          {loopClients.map((client, i) => (
            <div
              key={i}
              className="flex items-center gap-3 px-6 py-4 bg-[#fafaf8] border border-[#ede9e4] rounded-xl flex-shrink-0 hover:border-[#b8956a]/40 hover:bg-[#f8f5f1] transition-all duration-200 group"
            >
              <div className="w-9 h-9 flex items-center justify-center bg-[#f0ede8] rounded-lg group-hover:bg-[#b8956a]/15 transition-colors flex-shrink-0">
                <i className={`${client.icon} text-[#b8956a] text-base`}></i>
              </div>
              <div>
                <p className="text-[#1a1a1a] font-semibold text-sm whitespace-nowrap leading-tight">
                  {client.name}
                </p>
                <p className="text-[#b8b0a6] text-xs whitespace-nowrap mt-0.5">
                  {client.category}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Stats summary */}
      <div className="max-w-[1440px] mx-auto px-6 md:px-10 mt-10">
        <div className="flex flex-wrap items-center justify-center gap-8 md:gap-14">
          {[
            { value: '12+', label: '產業類別' },
            { value: '北中南', label: '全台服務' },
            { value: '5 星', label: 'Google 評價' },
            { value: '80%', label: '回頭合作率' },
          ].map((s) => (
            <div key={s.label} className="text-center">
              <p
                className="font-bold text-[#1a1a1a]"
                style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: '1.75rem', lineHeight: 1.1 }}
              >
                {s.value}
              </p>
              <p className="text-[#8a8a8a] text-xs mt-1">{s.label}</p>
            </div>
          ))}
        </div>
      </div>

      <style>{`
        @keyframes marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
      `}</style>
    </section>
  );
}
